import { UseBaseMutationOptions } from '@/core/api/type'
import { adminLogin } from '../../services/AuthService'
import { AuthMutationKey } from '@/modules/auth/keys'
import { LoginRequest, LoginResponse } from '@/modules/auth/type'
import { useMutation } from '@tanstack/react-query'

export default function useMutationLogin(
	props?: UseBaseMutationOptions<LoginResponse, LoginRequest>,
) {
	return useMutation({
		mutationKey: [AuthMutationKey.Login],
		mutationFn: (params) => adminLogin(params),
		...props,
	})
}
